import { useParams } from "react-router";

const ConstructionSitesDetail = () => {
  const { construction_site_uuid } = useParams();
  return <p>{construction_site_uuid} test</p>;
};

export default ConstructionSitesDetail;
